export default "__VITE_ASSET__CyJUFRyc__"